<div class="mtlr-3" style="display:flex;flex-direction: column;">
    <div>
        <app-webtrader-toolbox [selectedNode]="selectedNode" (buttonAction)="onButtonAction($event)"></app-webtrader-toolbox>
    </div>
  

    <div *ngIf="this.loading" style="padding-top: 300px;height: calc(100vh - 235px);">
        <app-loading />
    </div>

    <div *ngIf="selectedNode&&!this.loading">
        <div class="scroll-container flex-column" style="height: calc(100vh - 235px);">

            <div *ngIf="isInstanceOfFormlyView()">
                <app-formly-detailed-view  #formly_detailed_view_component [selectedNode]="selectedNode" (validate)="onValidate()" (modelChange)="onFormlyDetailedModelChange($event)"></app-formly-detailed-view>
            </div>

            <div *ngIf="isInstanceOfFormlyDrugIngredientsFormlyView()">
                <app-formly-drug-ingredients-view  #formly_detailed_view_component [selectedNode]="selectedNode" (validate)="onValidate()" (modelChange)="onFormlyDetailedModelChange($event)"></app-formly-drug-ingredients-view>
            </div>

            <div *ngIf="isInstanceOfListView() && (!isQueryListView()) && (!isBulkExport())">
                <app-list-detailed-view  [selectedNode]="selectedNode" (buttonAction)="onButtonAction($event)" (selectedNodeChange)="onSelectedNodeChange($event)" (removeNode)="onRemoveNode($event)"></app-list-detailed-view>
            </div>
            <div *ngIf="isBulkExport()">
                <app-file-list-detailed-view  [selectedNode]="selectedNode"></app-file-list-detailed-view>
            </div>
            <div *ngIf="isQueryListView()">
                <app-item-finder [selectedNode]="selectedNode" (itemFinderDoubleClick)="onItemFinderDoubleClick($event)" (selectedNodeChange)="onSelectedNodeChange($event)"></app-item-finder>
            </div>
        </div>    
    </div>
</div>
